"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreditLimit = void 0;
const utils_fetch_1 = __importDefault(require("@gcloud-npm/utils.fetch"));
const utils_monitoring_sonda_1 = __importDefault(require("@gcloud-npm/utils.monitoring.sonda"));
const utils_monitoring_get_uuid_1 = __importDefault(require("@gcloud-npm/utils.monitoring.get-uuid"));
const processName = "ADABYRON-API";
const getCreditLimit = ({ userIdPartyHash }) => __awaiter(void 0, void 0, void 0, function* () {
    const idRequest = (0, utils_monitoring_get_uuid_1.default)();
    let sonda = new utils_monitoring_sonda_1.default({
        eventName: "CREDIT.GET_CREDIT_LIMIT",
        context: {},
        uniqueId: idRequest,
        origin: processName,
    });
    let URL_API = "https://layer.col.movistar.es/movistar-layer/api/open/perso/v2/info/get";
    let userIdPartyHash2Use = userIdPartyHash;
    if (localStorage.getItem('AUTH_DEBUG_ID_PARTY_HASH')) {
        userIdPartyHash2Use = localStorage.getItem('AUTH_DEBUG_ID_PARTY_HASH');
        console.warn('has mockeado', userIdPartyHash2Use);
    }
    const request = new utils_fetch_1.default({
        method: "POST",
        endpoint: URL_API,
        data: {
            clientPartyId: userIdPartyHash2Use
        },
        headers: {},
        sonda,
    });
    return yield request.makeRequest();
});
exports.getCreditLimit = getCreditLimit;
exports.default = exports.getCreditLimit;
//# sourceMappingURL=index.js.map